import React, { useState, useEffect } from "react";
import "./Settlement.css";
import { useNavigate } from "react-router-dom";
import { db, storage } from "../firebase";
import { collection, query, where, getDocs, doc, getDoc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import jsPDF from "jspdf";

const NotesheetDownload = () => {
  const navigate = useNavigate();
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [actionPlan, setActionPlan] = useState([]);

  useEffect(() => {
    if (sessionStorage.getItem("login") !== "true") {
      navigate("/");
    }
  }, []);

  const name = localStorage.getItem("empname");
  const empId = localStorage.getItem("empid");

  useEffect(() => {
    if (sessionStorage.getItem("login") !== "true") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    if (!month || !year) return;

    const fetchActionPlan = async () => {
      try {
        const q = query(
          collection(db, "actionplan"),
          where("month", "==", `${month} ${year}`)
        );
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          setActionPlan([]);
          return;
        }

        const actions = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          // Apply filter: only include documents where sshremarks is not empty
          if (data.sshremarks && data.sshremarks !== "") {
            actions.push({
              id: doc.id,
              code: data.programCode || "",
              text: data.program || "",
              acsettlement: data.acsettlement || "",
              vcapproval: data.vcapproval || "",
              myempid: data.empid || "",
              kvk: data.kvk || "",
              empname: data.empname || "",
              empdesig: data.empdesig || "",
              accremarks: data.accremarks || "",
              sshremarks: data.sshremarks || "" // Add sshremarks
            });
          }
        });

        setActionPlan(actions);
      } catch (error) {
        console.error("Error fetching action plans:", error);
      }
    };

    fetchActionPlan();
  }, [month, year]);

  const fetchSettlementData = async (id) => {
    try {
      const docRef = doc(db, "actionplan", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return docSnap.data();
      } else {
        console.error("No such document!");
        return null;
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      return null;
    }
  };

  const handleFileUpload = async (event, id) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const storageRef = ref(storage, `vc_approvals/${id}_${file.name}`);
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);

      const docRef = doc(db, "actionplan", id);
      await updateDoc(docRef, { vcapproval: downloadURL });

      setActionPlan((prev) =>
        prev.map((item) => (item.id === id ? { ...item, vcapproval: downloadURL } : item))
      );

      alert("VC Approval uploaded successfully!");
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Failed to upload file.");
    }
  };

  const getImagePath = (empid) => {
    if (["1", "2", "3", "4", "5", "6", "37", "42", "47", "52", "57", "62", "63", "72", "73", "82"].includes(empid)) return "/assets/kalimpong.jpg";
    if (["7", "8", "9", "10", "11", "12", "38", "43", "48", "53", "58", "64", "65", "74", "75"].includes(empid)) return "/assets/coochbehar.jpg";
    if (["13", "14", "15", "16", "17", "18", "39", "44", "49", "54", "59", "66", "67", "76", "77"].includes(empid)) return "/assets/uttardinajpur.jpg";
    if (["19", "20", "21", "22", "23", "24", "40", "45", "50", "55", "60", "68", "69", "78", "79"].includes(empid)) return "/assets/dakshindinajpur.jpg";
    if (["25", "26", "27", "28", "29", "30", "41", "46", "51", "56", "61", "70", "71", "80", "81"].includes(empid)) return "/assets/malda.jpg";
    return null;
  };
  const getImagePath2 = (empid) => {
    if (["1", "2", "3", "4", "5", "6", "37", "42", "47", "52", "57", "62", "63", "72", "73", "82"].includes(empid)) return "/assets/kalimpong2.jpg";
    if (["7", "8", "9", "10", "11", "12", "38", "43", "48", "53", "58", "64", "65", "74", "75"].includes(empid)) return "/assets/coochbehar2.jpg";
    if (["13", "14", "15", "16", "17", "18", "39", "44", "49", "54", "59", "66", "67", "76", "77"].includes(empid)) return "/assets/uttardinajpur2.jpg";
    if (["19", "20", "21", "22", "23", "24", "40", "45", "50", "55", "60", "68", "69", "78", "79"].includes(empid)) return "/assets/dakshindinajpur2.jpg";
    if (["25", "26", "27", "28", "29", "30", "41", "46", "51", "56", "61", "70", "71", "80", "81"].includes(empid)) return "/assets/malda2.jpg";
    return null;
  };

  const handleDownloadPDF = async (id, myempid) => {
    const data = await fetchSettlementData(id);
    if (!data) return;

    const empDocRef = doc(db, "empmaster", myempid);
    const empSnap = await getDoc(empDocRef);
    const empData = empSnap.data();
    const { desig, signature: base64Signature } = empData;
    window.isdeeremarks = ""
    if (data.deeremarks == "Not Applicable" || data.deeremarks == "") {
      window.isdeeremarks = "NA"
      window.imagePath = getImagePath2(myempid)
    }
    else {
      window.isdeeremarks = "OK"
      window.imagePath = getImagePath(myempid)
    }

    const demandDate = data.demanddate?.toDate?.().toLocaleDateString("en-GB") || "N/A";
    const accDate = data.accdate?.toDate?.().toLocaleDateString("en-GB") || "N/A";
    const ddoDate = data.ddodate?.toDate?.().toLocaleDateString("en-GB") || "N/A";
    const sshDate = data.sshdate?.toDate?.().toLocaleDateString("en-GB") || "N/A";
    const deeDate = data.deedate?.toDate?.().toLocaleDateString("en-GB") || "N/A";

    const img = new Image();
    img.src = window.imagePath;

    img.onload = () => {
      const pdf = new jsPDF("p", "mm", "a4");
      pdf.addImage(img, "JPG", 0, 0, 210, 297);

      pdf.setFont("helvetica");
      pdf.setFontSize(10);

      pdf.text(`${data.programCode || "N/A"}`, (650 / 300) * 25.4, (610 / 300) * 25.4);
      pdf.text(`${data.budgethead || "N/A"}`, (1550 / 300) * 25.4, (610 / 300) * 25.4);
      pdf.text(`${data.program || "N/A"}`, (640 / 300) * 25.4, (670 / 300) * 25.4);
      pdf.text(pdf.splitTextToSize(data.td, 180), (250 / 300) * 25.4, (840 / 300) * 25.4);
      pdf.text(pdf.splitTextToSize(data.budgetdemand, 180), (450 / 300) * 25.4, (1180 / 300) * 25.4);
      pdf.text(`Total Amount: Rs.${data.totamount || 0}`, 90, 128);
      pdf.text(`Submitted to Assistant on : ${demandDate || 0}`, 10, 128);

      // if (base64Signature) {
      pdf.addImage(base64Signature, "PNG", (1650 / 300) * 25.4, (1150 / 300) * 25.4, 40, 20);
      // }
      pdf.text(`${data.empname || "N/A"}`, (1700 / 300) * 25.4, (1428 / 300) * 25.4);
      pdf.text(`${data.empdesig || "N/A"}`, (1740 / 300) * 25.4, (1490 / 300) * 25.4);


      pdf.text(pdf.splitTextToSize(data.accremarks, 130), (750 / 300) * 25.4, (1600 / 300) * 25.4);
      pdf.text(`${accDate}`, 36, 149);
      pdf.text(pdf.splitTextToSize(data.ddoremarks, 130), (700 / 300) * 25.4, (1960 / 300) * 25.4);
      pdf.text(`${ddoDate}`, 35, 187);
      pdf.text(pdf.splitTextToSize(data.sshremarks, 130), (765 / 300) * 25.4, (2382 / 300) * 25.4);
      pdf.text(`${sshDate}`, 35, 210);
      if (window.isdeeremarks == "OK") {
        pdf.text(`${data.deeremarks || "N/A"}`, (715 / 300) * 25.4, (2632 / 300) * 25.4);
        pdf.text(`${deeDate}`, 37, 243);
      }
      pdf.save(`Settlement_${id}.pdf`);
    };

    img.onerror = () => {
      alert("Failed to load image background.");
    };
  };
  const handleDownloadPDF2 = async (id, myempid) => {
    const data = await fetchSettlementData(id);
    if (!data) return;

    const empDocRef = doc(db, "empmaster", myempid);
    const empSnap = await getDoc(empDocRef);
    const empData = empSnap.data();
    const { desig, signature: base64Signature } = empData;
    window.isdeeremarks = ""
    if (data.deeremarks == "Not Applicable" || data.deeremarks == "") {
      window.isdeeremarks = "NA"
      window.imagePath = "/assets/deepad.jpg"
    }
    else {
      window.isdeeremarks = "OK"
      window.imagePath = "/assets/deepad.jpg"

    }




    const demandDate = data.demanddate?.toDate?.().toLocaleDateString("en-GB") || "N/A";
    const accDate = data.accdate?.toDate?.().toLocaleDateString("en-GB") || "N/A";
    const ddoDate = data.ddodate?.toDate?.().toLocaleDateString("en-GB") || "N/A";
    const sshDate = data.sshdate?.toDate?.().toLocaleDateString("en-GB") || "N/A";
    const deeDate = data.deedate?.toDate?.().toLocaleDateString("en-GB") || "N/A";

    const img = new Image();
    img.src = window.imagePath;

    img.onload = () => {
      const pdf = new jsPDF("p", "mm", "a4");
      pdf.addImage(img, "JPG", 0, 0, 210, 297);

      pdf.setFont("helvetica");
      pdf.setFontSize(11);

      pdf.text(`Program Code: ${data.programCode || "N/A"}`, (250 / 300) * 25.4, (1270 / 300) * 25.4);
      pdf.text(`Program Name: ${data.program || "N/A"}`, (250 / 300) * 25.4, (1330 / 300) * 25.4);
      pdf.text(`Budget Head: ${data.budgethead || "N/A"}`, (250 / 300) * 25.4, (1390 / 300) * 25.4);
      pdf.text(`Marked to: ${data.empname || "N/A"}, ${data.empdesig || "N/A"}`, (250 / 300) * 25.4, (2528 / 300) * 25.4);
      pdf.text(`Copy to: Head/DDO, KVK ${data.kvk || "N/A"}`, (250 / 300) * 25.4, (2628 / 300) * 25.4);

   

      // Handle budgetDemand with text wrapping
     // const maxWidth = 180; // Reasonable width for A4 page (adjust as needed)
     // const budgetDemandText = String(data.budgetdemand || "0"); // Ensure it's a string
     // const lines = pdf.splitTextToSize(budgetDemandText, maxWidth);
     // pdf.setFontSize(11);
     // pdf.text(lines, 20, 122); // Removed redundant maxWidth option in text()
     // pdf.setFontSize(12);
      pdf.text(pdf.splitTextToSize(data.budgetdemand, 210), (640 / 300) * 25.4, (1680 / 300) * 25.4);
      pdf.text(`Total Amount: Rs.${data.totamount || 0}`, 55, 190);  
      pdf.save(`Settlement_${id}.pdf`);
    };

    img.onerror = () => {
      alert("Failed to load image background.");
    };
  };

  const handleBack = (e) => {
    e.preventDefault();
    navigate(-1)
  }
  return (
    <div className="container">
      <h1 className="welcome">Notesheet Download</h1>

      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label className="label">Select Month and Year:</label>
          <select className="dropdown" value={month} onChange={(e) => setMonth(e.target.value)}>
            <option value="">Month</option>
            {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
        &nbsp;
        <select className="dropdown" value={year} onChange={(e) => setYear(e.target.value)} style={{ width: "150px", height: "40px", marginTop: "33px" }}>
          <option value="">Year</option>
          {["2025", "2026", "2027", "2028"].map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>

      {actionPlan.length > 0 && (
        <div className="action-section">
          <table className="action-table">
            <thead>
              <tr>
                <th>KVK & Applicant</th>
                <th>Program Code & Title</th>
                <th>Settlement Status</th>
                <th>Download Notesheet</th>
                <th>Download Order</th>
                <th>Upload Approval of DEE/VC</th>
              </tr>
            </thead>
            <tbody>
              {actionPlan.map((action) => (
                <tr key={action.id}>
                  <td>{action.kvk} <br /> {action.empname} <br /> {action.empdesig}</td>
                  <td>{action.code} <br /> {action.text}</td>
                  <td>{action.acsettlement}</td>
                  <td><button onClick={() => handleDownloadPDF(action.id, action.myempid)}>Download</button></td>
                  <td><button onClick={() => handleDownloadPDF2(action.id, action.myempid)}>Download</button></td>
                  <td>
                    <input
                      type="file"
                      accept="application/pdf"
                      onChange={(e) => handleFileUpload(e, action.id)}
                    />
                    {action.vcapproval !== "No" && (
                      <a href={action.vcapproval} target="_blank" rel="noopener noreferrer">
                        View PDF
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <img src="/assets/back.png" style={{ width: '100px' }} onClick={handleBack} alt="" />

    </div>
  );
};

export default NotesheetDownload;
